module.exports = __webpack_public_path__ + "img/olehile-profile-min.641b791a.jpg";